import { useCallback, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { type TFindObjectsPayload, findMoreObjects } from 'slices/object.slice';

export const useTotal = (
  queries: Record<string, unknown>,
  showTotalNumber?: boolean
) => {
  const [total, setTotal] = useState(0);

  const fetchTotal = useCallback(async () => {
    try {
      const { totalResults } = await findMoreObjects({
        ...queries,
        active: 'TRUE',
        limit: 1,
      } satisfies TFindObjectsPayload);
      setTotal(totalResults);
    } catch (error) {
      console.error('Error fetching total number of objects:', error);
      setTotal(0);
    }
  }, [queries]);

  useEffect(() => {
    if (showTotalNumber) {
      if (!isEmpty(queries)) {
        fetchTotal();
      } else {
        setTotal(0);
      }
    }
  }, [fetchTotal, showTotalNumber]);

  return total;
};
